import styled from '@emotion/styled';

export const sizes = {
  tiny: ['16px', '16px', '6px', '3px', 16],
  small: ['24px', '24px', '8px', '6px', 24],
  medium: ['32px', '32px', '12px', '6px', 32],
  large: ['64px', '64px', '18px', '8px', 64],
};

export const AvatarFrame = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-height: ${({ size }) => sizes[size][0]};
  height: ${({ size }) => sizes[size][0]};
  width: ${({ size }) => sizes[size][1]};
  font-size: ${({ size }) => sizes[size][2]};
  margin: 2px 0 2px 2px;
  background-color: var(--ds-surface-overlay, #ffffff);
  border-radius: 50%;
`;

export const Avatar = styled.div`
  width: inherit;
  height: inherit;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  transition: all 0.2s ease-in-out;
  filter: ${({ isLoaded }) => (isLoaded ? '' : 'blur(20px)')};
  background-image: ${({ src }) => `url(${src})`};
`;

export const AvatarInitials = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: inherit;
  height: inherit;
  border-radius: 25em;
  border: 0;
  background-color: #dfe1e6;
  font-weight: 700;
  line-height: 32px;
  left: 0;
  top: 0;
  color: #172b4d;
  filter: ${({ isLoading }) => (isLoading ? 'blur(3px)' : '')};
`;

export const OnlineIdicator = styled.div`
  position: absolute;
  left: 63%;
  bottom: 3%;
  width: ${({ size }) => sizes[size][3]};
  height: ${({ size }) => sizes[size][3]};
  background: ${({ status }) => (status === 'online' ? '#43af11' : '#e30b5c')};
  border-color: white;
  border-style: solid;
  border-width: 1px;
  border-radius: 50%;
`;

export const SelectedMark = styled.div`
  position: absolute;
  bottom: -2px;
  width: ${({ size }) => sizes[size][1]};
  border-bottom: 1.8px solid green;
`;

export const Story = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ShowCase = styled.div`
  display: flex;
`;

export const ShowColumnCase = styled.div`
  display: flex;
  flex-direction: column;
`;
